// Skeleton.tsx
import { twMerge } from "tailwind-merge";
export function Skeleton({ className }: { className?: string }) {
  return <div className={twMerge("bg-surface-200 rounded animate-pulse", className)} />;
}